import { useEffect, useState } from "react";

const Apply = () => {
    const [fullName, SetFullName] = useState("");
    const [whatsapp, SetWhatsapp] = useState("");
    const [email, SetEmail] = useState("");
    const [website, SetWebsite] = useState("");
    const [cv, SetCv] = useState(null);
    const [errorMessage, SetErrorMessage] = useState("");
    const [submitting, SetSubmitting] = useState(false);
    const [success, SetSuccess] = useState(false);

    const BACKEND_URL =
        process.env.NODE_ENV === "production"
            ? "https://api.davidchavez.tech"
            : "http://localhost:3009";

    const handleSubmit = async (e) => {
        e.preventDefault();
        const form = e.currentTarget;

        if (!fullName || !whatsapp || !email || !website || !cv) {
            SetErrorMessage("Por favor completa todos los campos");
            return;
        }

        SetErrorMessage("");
        SetSubmitting(true);

        try {
            const formData = new FormData();
            formData.append("fullName", fullName);
            formData.append("whatsapp", whatsapp);
            formData.append("email", email);
            formData.append("website", website);
            formData.append("cv", cv);

            const response = await fetch(`${BACKEND_URL}/apply`, {
                method: "POST",
                body: formData,
            });

            const data = await response.json();

            if (!response.ok) {
                SetErrorMessage(
                    data.error || "Ocurrió un error. Intenta de nuevo."
                );
                return;
            }

            SetSuccess(true);
            SetFullName("");
            SetWhatsapp("");
            SetEmail("");
            SetWebsite("");
            SetCv(null);
            form.reset();
        } catch (err) {
            SetErrorMessage(
                "No se pudo enviar tu postulación. Intenta de nuevo."
            );
        } finally {
            SetSubmitting(false);
        }
    };

    useEffect(() => {
        if (fullName || whatsapp || email || website || cv) {
            SetSuccess(false);
        }
        if (fullName && whatsapp && email && website && cv) {
            SetErrorMessage("");
        }
    }, [fullName, whatsapp, email, website, cv]);

    return (
        <div className="flex justify-center px-6 py-16">
            <div className="w-full max-w-[700px] flex flex-col">
                <h1 className="text-4xl mb-10 text-animate show">
                    Posición de desarrollador frontend
                </h1>

                <div className="flex flex-col gap-y-2 mb-12 text-gray-300 leading-relaxed">
                    <p>📍 Trabajo presencial en Chiclayo</p>
                    <p>🕘 Horario: Lunes a Viernes de 9:00 AM a 5:00 PM</p>
                    <p>
                        💰 Sueldo: S/ 3,000 mensuales{" "}
                        <span className="highlighted-text">
                            (Con potencial de crecimiento salarial)
                        </span>
                    </p>

                    <p className="mt-6 text-white">
                        Buscamos una persona con experiencia en:
                    </p>
                    <ul className="flex flex-col gap-y-1">
                        <li>✅ 3 años de experiencia con ReactJS</li>
                        <li>✅ JavaScript / TypeScript</li>
                        <li>✅ HTML y CSS</li>
                        <li>✅ Git</li>
                        <li>✅ Consumo de APIs REST</li>
                    </ul>

                    <p className="mt-6 text-white">Habilidades deseables:</p>
                    <ul className="flex flex-col gap-y-1">
                        <li>⭐ Inglés</li>
                        <li>⭐ Shopify</li>
                        <li>⭐ AWS</li>
                        <li>⭐ Conocimientos de backend</li>
                        <li>⭐ Server side rendering</li>
                    </ul>

                    <p className="mt-6 text-white">📝 Proceso de selección:</p>
                    <ul className="flex flex-col gap-y-1">
                        <li>1️⃣ Revisión de CV</li>
                        <li>2️⃣ Entrevista online sobre tu experiencia</li>
                        <li>3️⃣ Prueba pagada de dos semanas</li>
                    </ul>
                </div>

                <form className="flex flex-col gap-y-5" onSubmit={handleSubmit}>
                    <input
                        className="px-1 bg-transparent border-b w-full border-gray-400 py-2"
                        type="text"
                        placeholder="Nombre completo"
                        value={fullName}
                        onChange={(e) => SetFullName(e.currentTarget.value)}
                    />
                    <input
                        className="px-1 bg-transparent border-b w-full border-gray-400 py-2"
                        type="tel"
                        placeholder="Whatsapp"
                        value={whatsapp}
                        onChange={(e) => SetWhatsapp(e.currentTarget.value)}
                    />
                    <input
                        className="px-1 bg-transparent border-b w-full border-gray-400 py-2"
                        type="email"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => SetEmail(e.currentTarget.value)}
                    />
                    <input
                        className="px-1 bg-transparent border-b w-full border-gray-400 py-2"
                        type="text"
                        placeholder="Sitio web / Portafolio"
                        value={website}
                        onChange={(e) => SetWebsite(e.currentTarget.value)}
                    />

                    <label className="flex flex-col gap-y-2 mt-2 text-gray-300">
                        CV
                        <input
                            className="px-1 bg-transparent border-b w-full border-gray-400 py-2 file:mr-4 file:py-1 file:px-3 file:rounded file:border-0 file:bg-orange-500 file:text-white file:cursor-pointer cursor-pointer"
                            type="file"
                            accept=".pdf"
                            onChange={(e) => SetCv(e.currentTarget.files[0])}
                        />
                    </label>

                    <button
                        className={`${
                            errorMessage ? "bg-red-800" : "bg-orange-500"
                        } py-2 rounded flex justify-center mt-4 disabled:opacity-60`}
                        type="submit"
                        disabled={submitting}
                    >
                        {submitting
                            ? "Enviando..."
                            : errorMessage
                            ? errorMessage
                            : "Enviar postulación"}
                    </button>

                    {success && (
                        <p className="text-green-400 text-center mt-2">
                            ¡Postulación enviada! Gracias por aplicar.
                        </p>
                    )}
                </form>
            </div>
        </div>
    );
};

export default Apply;
